import ClassNames from 'classnames'
import PropTypes from 'prop-types'
import React from 'react'
import {
  Image
} from './../../custom'
import {
  LoadingWrapper
} from './styled'
import loadingIcon from './../../../themes/images/shareds/loading.svg'

export class Loading extends React.PureComponent {
  render() {
    const {
      className,
      active
    } = this.props

    // props for css classes
    const classes = ClassNames(
      'Loading',
      { 'is-active': active },
      className
    )

    return (
      <LoadingWrapper
        className={classes}
      >
        <Image
          widthRatio='100'
          widthRatioUnit='px'
          heightRatio='100'
          heightRatioUnit='px'
          src={loadingIcon}
        />
      </LoadingWrapper>
    )
  }

  static defaultProps = {
  }

  static propTypes = { // TYPE > node, string, number, bool, array, object, symbol, func
    className: PropTypes.string
  }
}
